import { createSlice } from "@reduxjs/toolkit";
import {
  LeadershipData,
  leadershipDataInitialStatus,
} from "../../../../../types/webCms/aboutUs/leadership";
import { getAllLeaderShipAsync, updateLeaderShipAsync } from "./leaderShipApi";

const initialState: leadershipDataInitialStatus<LeadershipData> = {
  loading: false,
  manageLoading: false,
  leadershipDataList: [],
  countLeadershipData: 0,
};

const LeaderShipSlice = createSlice({
  name: "admin-leadership",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllLeaderShipAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllLeaderShipAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.leadershipDataList = action.payload.data;
        state.countLeadershipData = action.payload.length;
      })
      .addCase(getAllLeaderShipAsync.rejected, (state) => {
        state.loading = false;
        state.leadershipDataList = [];
        state.countLeadershipData = 0;
      });

    // update
    builder
      .addCase(updateLeaderShipAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateLeaderShipAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateLeaderShipAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default LeaderShipSlice;
